import styled from 'styled-components';
import { P, fs, radius, eyebrow, onPhone, tint, tintB, tintT } from '../../theme/tokens';
import { DrawerBody, Section as BaseSection } from '../DrawerParts';
import { GhostBtn } from '../Buttons';

export const ReviewBtn = styled.button`
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: ${radius.pill}px;
  cursor: pointer;
  border: 1px ${(p) => (p.$on ? `solid ${tintB(P.success)}` : `dashed ${P.border}`)};
  background: ${(p) => (p.$on ? tint(P.success) : P.white)};
  color: ${(p) => (p.$on ? tintT(P.success) : P.muted)};

  &:hover {
    border-color: ${(p) => (p.$on ? tintT(P.success) : P.navy)};
  }
`;

export const Attention = styled.div`
  padding: 12px 14px;
  border-radius: ${radius.lg}px;
  font-size: ${fs.sm}px;
  background: ${tint(P.purple)};
  border: 1px solid ${tintB(P.purple)};
  color: ${tintT(P.purple)};

  b {
    display: block;
    color: ${P.ink};
    margin-bottom: 2px;
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 8px;

  button {
    height: 42px;
  }
  button:first-child {
    flex: 1;
    justify-content: center;
  }
`;

export const ActionLink = styled.button`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
  min-height: 44px;
  padding: 8px 12px;
  border: 0;
  border-bottom: 1px solid ${P.line};
  background: #fff;
  text-align: left;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  span {
    flex: 1;
    min-width: 0;
  }
  &:hover {
    background: ${P.bgSubtle};
  }
`;

export const SecHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;

  h3 {
    margin: 0;
    flex: 1;
    min-width: 0;
    font-family: inherit;
    font-size: ${fs.sm}px;
    font-weight: 700;
    color: ${P.ink};
    letter-spacing: 0;
    text-transform: none;
  }
  > svg {
    color: ${P.navyInk};
    font-size: 12px;
  }
`;

export const InfoGrid = styled.dl`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
  margin: 0;

  dt {
    ${eyebrow}
    margin-bottom: 2px;
  }
  dd {
    margin: 0;
    font-size: 12.5px;
    color: ${P.ink};
    overflow-wrap: anywhere;
  }
`;

export const Soft = styled.div`
  background: ${P.bgSubtle};
  border: 1px solid ${P.line};
  border-radius: ${radius.lg}px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12.5px;
  line-height: 1.55;
  color: ${P.ink};
`;

export const CatTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: ${fs.sm}px;
  color: ${P.navyInk};
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(p) => p.$c};
  flex: none;
`;

export const Bubbles = styled.ol`
  list-style: none;
  margin: 0;
  padding: 4px 4px 4px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 460px;
  overflow-y: auto;
  ${onPhone} {
    max-height: none;
    overflow-y: visible;
  }
`;

export const Turn = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: ${(p) => (p.$ai ? 'flex-start' : 'flex-end')};
`;

export const TurnWho = styled.div`
  ${eyebrow}
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${(p) => (p.$ai ? P.muted : P.navyInk)};

  svg {
    width: 15px;
    height: 15px;
    padding: 3px;
    border-radius: 50%;
    box-sizing: border-box;
    color: ${P.white};
    background: ${(p) => (p.$ai ? P.subtle : P.navyInk)};
  }
`;

export const Bubble = styled.div`
  max-width: 85%;
  padding: 7px 11px;
  font-size: 12.5px;
  line-height: 1.45;
  border-radius: 12px;
  ${(p) =>
    p.$ai
      ? `background: ${P.gray100}; color: ${P.ink}; border: 1px solid ${P.line}; border-top-left-radius: 4px;`
      : `background: ${P.grad}; color: ${P.white}; border-top-right-radius: 4px;`}
`;

export const Ids = styled.div`
  padding: 8px 12px;
  border-radius: ${radius.lg}px;
  background: ${P.white};
  border: 1px solid ${P.line};
  font-size: 11px;
  color: ${P.subtle};
  overflow-wrap: anywhere;
`;

export const Icon = styled.button`
  border: 0;
  background: none;
  color: ${P.muted};
  cursor: pointer;
  padding: 6px;
  border-radius: ${radius.sm}px;
  ${onPhone} {
    min-width: 40px;
    min-height: 40px;
  }
  &:hover {
    color: ${P.navyInk};
    background: ${P.gray100};
  }
`;

export const Section = styled(BaseSection)`
  padding: 12px 14px;
`;

export const Body = styled(DrawerBody)`
  padding: 14px 16px;
  gap: 10px;
`;

export const SmallBtn = styled(GhostBtn)`
  height: 28px;
  padding: 0 10px;
  gap: 6px;
  font-size: 12px;
  ${onPhone} {
    height: 36px;
    padding: 0 14px;
  }
`;
